var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextEdit',_vm._b({attrs:{"fallback":_vm.stringFallback,"type":"number"},on:{"save":function($event){return _vm.$emit('save', $event)},"cancel":function($event){return _vm.$emit('cancel', $event)}},model:{value:(_vm.stringValue),callback:function ($$v) {_vm.stringValue=$$v},expression:"stringValue"}},'TextEdit',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }